  // window.addEventListener("scroll", function () {
  //   const searchBar = document.querySelector("header.header .search-modal__form");

  //   if (window.innerWidth <= 768 && searchBar) {
  //     if (window.scrollY > 130) {
  //       searchBar.style.display = "none";
  //     } else {
  //       searchBar.style.display = "block";
  //     }
  //   }
  // });

    $(document).ready(function(){
    $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportHalf = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportHalf;
    };
          $('.add_to_stickyy').addClass('fixed-on-scroll');

    setTimeout(function(){
    $(window).scroll(function () {
    if ($('.product-form').isInViewport()) {
    $('.add_to_stickyy').css('display' , 'none' );
    $('.add_to_stickyy').removeClass('fixed-on-scroll');
    }
    else{
    $('.add_to_stickyy').css('display' , 'flex' );
    $('.add_to_stickyy').addClass('fixed-on-scroll');
    }
    });
      
    $('.add_to_stickyy').removeClass('white_color');
          $(window).scroll(function () {
    if ($('.footer').isInViewport()) {
    $('.add_to_stickyy').addClass('white_color');
    }
    else{
    $('.add_to_stickyy').removeClass('white_color');
    }
    });



      
    }, 0);
    });
